import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(3),
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(0.5),
    cursor: 'grab !important',
  },
  icon: {
    display: 'flex',
    width: '24px',
    height: '24px',
    color: theme.palette.labraIcon.main,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    flexShrink: 0,
    cursor: 'pointer',
  },
  iconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    alignSelf: 'stretch',
    flex: 1,
  },
  inputButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2.5),
    alignItems: 'flex-start',
    width: '100%',
  },
  dragContainer: {
    marginTop: theme.spacing(3),
  },
  horizontalDivider: {
    height: '1px',
    backgroundColor: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(-8),
    marginRight: theme.spacing(-4),
  },
  productInputBlock: {
    flex: 1,
  },
  headingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  title: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
  titlecards: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
